module.exports = __webpack_public_path__ + "static/media/logo.krypto-500x500.a3075eaa.png";